<template>
	<div v-if="isVisible" class="layer_bg" @click="closePopup">
		<div class="layer_popup" @click.stop>
			<button class="btn_close" @click="closePopup">X</button>

			<h2 class="title_layer">{{ title }}</h2>

			<div class="content">
				<slot name="layer_content"></slot>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
	name: 'LayerPopup',
	props: {
		modelValue: {
			type: Boolean,
			required: true
		},
		title: {
			type: String,
			default: 'Popup Title'
		}
	},
	computed: {
		isVisible: {
			get() {
				return this.modelValue;
			},
			set(value) {
				this.$emit('update:modelValue', value);
			}
		}
	},
	methods: {
		closePopup() {
			this.isVisible = false;
		}
	}
};
</script>